/**
 * 风险词软提示条（story AC-9，非阻断）。浅黄关怀语气，不回显关键词、无警告 emoji。
 * 文案沿源页 UX-DR18：站内交易获评价 + 退款保护。可单次关闭。
 */
interface RiskBannerProps {
  onClose: () => void;
}

export function RiskBanner({ onClose }: RiskBannerProps) {
  return (
    <div
      className="xs"
      role="note"
      style={{
        background: '#FFF9E6',
        borderLeft: '3px solid var(--color-primary)',
        borderRadius: 'var(--radius-md)',
        padding: 'var(--space-2) var(--space-3)',
        marginBottom: 'var(--space-1)',
        color: 'var(--color-foreground)',
        display: 'flex',
        alignItems: 'center',
        gap: 'var(--space-2)',
        maxWidth: '60%',
      }}
    >
      <span style={{ flex: 1 }}>建议在站内完成交易，可获得评价与退款保护。</span>
      <button
        type="button"
        aria-label="关闭提示"
        onClick={onClose}
        style={{
          background: 'transparent',
          border: 'none',
          cursor: 'pointer',
          color: 'var(--color-muted-foreground)',
          lineHeight: 1,
        }}
      >
        ×
      </button>
    </div>
  );
}
